import React, { memo } from "react";
import { CommercialTitle } from "../commercial-title";
import { CommercialText } from "../commercial-text";
import { Commercial } from "../../../types";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import styled from "styled-components";
import { CommercialService } from "../../../services/commercial-service";
import { useTranslation } from "react-i18next";
import { GolTooltip } from "../../tooltip/tooltip";
interface ICommercialsEventItemProps {
  commercial: Commercial;
}

const TitleGroup = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CommercialEvent = styled.div`
  background-color: ${(props) => props.theme.informationTextBackgroundColor};
  border-radius: 0 5px 5px 5px;
  padding: 12px 14px;
  margin-bottom: 32px;
`;

const Legend = styled.div`
  width: 100%;
  text-align: left;
  font-size: 12px;
  color: ${(props) => props.theme.disabledColor};
  margin-top: -8px;
  margin-bottom: 8px;
`;

const Item = (props: ICommercialsEventItemProps) => {
  const { i18n } = useTranslation();
  const commercialService = new CommercialService(
    props.commercial,
    i18n.language
  );
  return (
    <CommercialEvent data-test="commercial-event">
      <TitleGroup>
        <CommercialTitle
          title={commercialService.name}
          icon={<FlashOnIcon />}
        />
        <GolTooltip
          title={commercialService.name}
          text={commercialService.description}
        />
      </TitleGroup>
      {commercialService.hasPrepayment && (
        <Legend data-test="menu-offer-prepayment-infos">
          {commercialService.prepaymentInfos}
        </Legend>
      )}
      <CommercialText text={commercialService.description} />
    </CommercialEvent>
  );
};

export const CommercialsEventItem = memo(Item);
